document.addEventListener('product:added', function(event) {
  // Cherche le formulaire — soit depuis event.target, soit le premier formulaire produit sur la page
  var form = (event.target && event.target.closest('form[action*="/cart/add"]'))
    || document.querySelector('form[action*="/cart/add"]');
  
  var variantId = null;
  var quantity = 1;

  if (form) {
    var variantIdInput = form.querySelector('[name="id"]');
    if (variantIdInput) variantId = variantIdInput.value;
    quantity = parseInt(form.querySelector('[name="quantity"]')?.value) || 1;
  }

  // Fallback : tente de lire l'ID depuis le detail de l'événement
  if (!variantId && event.detail && event.detail.variant) {
    variantId = event.detail.variant.id;
  }

  console.log('[Klaviyo Debug] product:added fired — variantId:', variantId, '| quantity:', quantity);

  if (window._learnq && variantId) {
    window._learnq.push(['track', 'Added to Cart', {
      $value: null,
      AddedItemProductName: document.querySelector('.product-meta__title, h1.product__title, .product-single__title')?.innerText || '',
      AddedItemVariantID: variantId,
      AddedItemQuantity: quantity,
      ItemNames: [document.querySelector('.product-meta__title, h1.product__title')?.innerText || ''],
    }]);
    console.log('[Klaviyo Debug] _learnq push done');
  }
});